import { connect } from 'react-redux';

import { ReduxState } from 'app/redux/types';

import Container, {
  ContainerProps,
} from '../../components/Container';
import { activeLevel } from '../../selectors/live';

const mapStateToProps = (state: ReduxState): ContainerProps => ({
  activeLevel: activeLevel(state),
});

export default connect(mapStateToProps)(Container);
